var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRoundCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16675 12.75C1.16682 12.0156 1.34023 11.2915 1.67288 10.6367C2.00553 9.98195 2.48804 9.41492 3.08115 8.98177C3.67425 8.54862 4.36122 8.26157 5.08619 8.14398C5.81115 8.02638 6.55363 8.08155 7.25325 8.305M11.3751 8.84167L11.1417 9.36667M9.85841 12.6333L9.62508 13.1583M12.6584 11.875L12.1334 11.6417M8.86675 10.3583L8.34175 10.125M12.6584 10.125L12.1334 10.3583M8.86675 11.6417L8.34175 11.875M11.3751 13.1583L11.1417 12.6333M9.85841 9.36667L9.62508 8.84167M8.75008 5.16667C8.75008 6.7775 7.44425 8.08333 5.83341 8.08333C4.22258 8.08333 2.91675 6.7775 2.91675 5.16667C2.91675 3.55584 4.22258 2.25 5.83341 2.25C7.44425 2.25 8.75008 3.55584 8.75008 5.16667ZM12.2501 11C12.2501 11.9665 11.4666 12.75 10.5001 12.75C9.53358 12.75 8.75008 11.9665 8.75008 11C8.75008 10.0335 9.53358 9.25 10.5001 9.25C11.4666 9.25 12.2501 10.0335 12.2501 11Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRoundCog);
export default __webpack_public_path__ + "static/media/user-round-cog.56685bf15d45cd087803d3acc42c80ab.svg";
export { ForwardRef as ReactComponent };